import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { BannerImageModel } from "../../../models";
import { ModelId } from "../../../../defines";
import { BannerEditorPictures } from "../../../../components/manager-profile/BannerEditor";

export function apiBannerImageModel(opts: ApiModelOptions<BannerImageModel>) {
  const model = ApiModel<BannerImageModel>("banner-image", opts);

  const getLayoutFormData = (
    layout: number,
    images: BannerEditorPictures,
    usePositions = false,
  ) => {
    const formData = new FormData();
    formData.append("layout", `${layout}img`);

    images.forEach((image, index) => {
      if (!image) return;

      const postIndex = usePositions ? index + 1 : "";

      formData.append(
        `crops[${postIndex}]`,
        `${parseInt(String(image.position.x * 1000))}x${parseInt(
          String(image.position.y * 1000),
        )}+${image.scale}`,
      );

      if (image.originalFile?.file) {
        formData.append(
          `full_size_images[${postIndex}]`,
          image.originalFile.file,
          image.originalFile.file.name,
        );
        formData.append(
          `cropped_images[${postIndex}]`,
          image.croppedImage,
          image.originalFile.file.name.replace(/\.([^.]+)$/g, "-cropped.$1"),
        );
      } else if (image.croppedImage) {
        formData.append(
          `cropped_images[${postIndex}]`,
          image.croppedImage,
          "cropped-image",
        );
      }
    });

    return formData;
  };

  const createOpportunityLayout = async (
    opportunityId: ModelId,
    layout: number,
    images: BannerEditorPictures,
  ) => {
    const formData = getLayoutFormData(layout, images);
    formData.append("opportunity_id", String(opportunityId));

    return await model.handler.post("/banners", formData);
  };

  const updateOpportunityLayout = async (
    opportunityId: ModelId,
    layout: number,
    images: BannerEditorPictures,
  ) => {
    const formData = getLayoutFormData(layout, images, true);
    formData.append("opportunity_id", String(opportunityId));

    return await model.handler.patch("/banners", formData, false);
  };

  const createManagerLayout = async (
    managerId: ModelId,
    layout: number,
    images: BannerEditorPictures,
  ) => {
    const formData = getLayoutFormData(layout, images);
    formData.append("manager_id", String(managerId));

    return await model.handler.post("/banners", formData);
  };

  const updateManagerLayout = async (
    managerId: ModelId,
    layout: number,
    images: BannerEditorPictures,
  ) => {
    const formData = getLayoutFormData(layout, images, true);
    formData.append("manager_id", String(managerId));

    return await model.handler.patch("/banners", formData, false);
  };

  const getOriginalBannerImageDataUrl = async (bannerId: ModelId) => {
    const response = await model.handler.get<{ data: string }>(
      `/banners/${bannerId}/original-image?manager_id=1`,
      false,
    );
    return response?.data || null;
  };

  return {
    ...model,
    createOpportunityLayout,
    updateOpportunityLayout,
    createManagerLayout,
    updateManagerLayout,
    getOriginalBannerImageDataUrl,
  };
}
